import { getVoucherCode } from "../../../../models/Ticket";
import { RowData } from "./types";

export const voucherCellValueGetter = ({ data }: { data: RowData }) => {
    if ("balance" in data) {
        return null;
    }

    if (data.isOrganizer && data.item.tickets?.length) {
        return getVoucherCode(data.item.tickets);
    }

    return null;
};

export const VoucherCellFormatter = ({ value }: { value: string | undefined }) => value ?? "";
